(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    (function () {
    function initBackToTop() {
      var button = document.getElementById('OnixBackToTop');
      var ring = document.getElementById('OnixScrollRing');
      if (!button) return;

      var circumference = 138.2;

      function getScrollPercent() {
        var scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
        var docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        return docHeight > 0 ? scrollTop / docHeight : 0;
      }

      function update() {
        var scrollY = window.scrollY || document.documentElement.scrollTop || 0;
        button.classList.toggle('is-visible', scrollY > 120);

        if (ring) {
          var progress = getScrollPercent();
          var offset = circumference - (progress * circumference);
          ring.style.strokeDashoffset = offset;
        }
      }

      button.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });

      update();
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBackToTop, { once: true });
      return;
    }

    initBackToTop();
  })();
  } catch(e) { console.error(e); }
})();

})();
